export default "__VITE_ASSET__Cb1aid6E__"